import { useDispatch, useSelector } from "react-redux";
import { Root } from "../../state/types";
import { ChangeEvent } from "react";
import { updateQrText } from "../../state/mainSlice";
import { TextField } from "@mui/material";

interface Props {
    record(): void
}

  
const TextAreaInput = ({ record }: Props) => {
    const dispatch = useDispatch();
    const value = useSelector((state: Root) => state.qrData.qrText);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(updateQrText(e.target.value));
    };

    const onBlur = (event: any) => {
        record();
    }
  
    return (
        <TextField
          variant="outlined"
          value={value}
          onChange={onChange}
          placeholder="Enter text"
          multiline
          rows={4}
          onBlur={onBlur}
          fullWidth
        />
    );
};

export default TextAreaInput;